import Dialog from "@material-ui/core/Dialog";
import {Box, InputAdornment, TextField, Typography} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import * as React from "react";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import './DateSelection.css'
import searchIcon from "../../assets/images/search-normal.svg";
import {useState} from "react";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {convertToBirthDate} from "../../utils/numberConvertor";
import {
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";

const DateSelection = (
    {
        openDateSelectionDialog,
        handleCloseOpenDateDialog,
        setFilter
    }) => {

    const snackbar = useSnackbarDispatcher()

    //Dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    const [filterDate, setFilterDate] = useState("");
    const [filterDateSubmitted, setFilterDateSubmitted] = useState("");

    const [filterPayer, setFilterPayer] = useState("ALL");
    //Dialog-end
    return (
        <Dialog onClose={handleCloseOpenDateDialog} aria-labelledby="customized-dialog-title"
                open={openDateSelectionDialog}
                id="PersonalizedDialog">
            <DialogTitle id="customized-dialog-title" onClose={handleCloseOpenDateDialog}>
                فیلتر ها
            </DialogTitle>
            <section className="p-2">
                <Box className="d-flex flex-column">
                    <RaikoGridOneColumn>
                        <TextField
                            value={convertToBirthDate(filterDate)}
                            onChange={e => {
                                setFilterDate(convertToBirthDate(e.target.value))
                            }}
                            className="w-100 h-100"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <img src={searchIcon} alt=""/>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined" label="تاریخ پرداخت"
                            placeholder="تاریخ مورد نظر را وارد نمایید..."
                        />

                        <TextField
                            value={convertToBirthDate(filterDateSubmitted)}
                            onChange={e => {
                                setFilterDateSubmitted(convertToBirthDate(e.target.value))
                            }}
                            className="w-100 h-100"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <img src={searchIcon} alt=""/>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined" label="تاریخ ثبت"
                            placeholder="تاریخ مورد نظر را وارد نمایید..."
                        />

                        <RaikoCustomSelect
                            labelText={"واریز کننده"}
                            value={filterPayer}
                            setValue={setFilterPayer}
                            items={[
                                raikoCustomSelectItemGenerator("ALL", "همه"),
                                raikoCustomSelectItemGenerator("MANAGER", "مدیر"),
                                raikoCustomSelectItemGenerator("MEMBER", "کاربر"),
                            ]}
                        />
                    </RaikoGridOneColumn>
                    <section className="d-flex flex-row flex-nowrap flex-grow-1 mt-3">

                        <Button className="w-100 btn-confirm"
                                style={{marginLeft: "8px"}}
                                onClick={e => {
                                    if (filterDate.length === 10 || filterPayer.length > 0) {
                                        setFilter(filterDate,filterDateSubmitted, filterPayer)
                                        handleCloseOpenDateDialog()
                                    } else
                                        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "تاریخ وارد شده صحیح نمی باشد!"))
                                }}>
                            اعمال فیلتر
                        </Button>

                        <Button className="w-100 btn-secondary"
                                style={{marginRight: "8px"}}
                                onClick={_ => {
                                    setFilter("")
                                    setFilterDate("")
                                    setFilterDateSubmitted("")
                                    handleCloseOpenDateDialog()
                                }}>
                            پاک کردن
                        </Button>
                    </section>

                </Box>

            </section>
        </Dialog>

    )
}
export default DateSelection